const APP_DATA = {
  popups: {
    createClass: {
      title: 'Create',
      description:
        'Select a time, participants, and send secure invites TalkPro link automatically',
    },
    editClass: {
      title: 'Edit',
      description:
        'Updates your event details, including time, participants, or fees.',
    },
    availability: {
      title: 'Availability',
      description:
        'Set your availability, synced with your calendar, and displayed on your public booking page.',
    },
    availabilityRatePage: {
      title: 'Share Availability',
      description:
        'Set your availability so clients can book times that work for you. This step is optional.',
    },
  },
}

export default APP_DATA
